import { MetricBand } from '@/components/dashboard/MetricBand';
import { useActiveUsersWindows, useDashboardMetrics } from '@/hooks/useDashboard';

/** Usuários únicos ativos em janelas reais (devices.last_seen), não mais gráfico mockado. */
export function ActiveUsersTrendCard() {
  const { data, isLoading } = useActiveUsersWindows();
  const { data: metricsData } = useDashboardMetrics();

  const active1d = data?.active1d ?? 0;
  const active1dPrevious = data?.active1dPrevious ?? 0;
  const dailyDiff = active1d - active1dPrevious;

  const dailyHint =
    active1dPrevious > 0 && dailyDiff !== 0 ? (
      <span className={`font-semibold ${dailyDiff > 0 ? 'text-success' : 'text-error'}`}>
        {dailyDiff > 0 ? '+' : '−'}
        {Math.abs(dailyDiff)}
      </span>
    ) : undefined;

  return (
    <MetricBand
      title="Usuários"
      caption="únicos ativos"
      loading={isLoading}
      metrics={[
        { label: 'Hoje', value: active1d.toLocaleString(), hint: dailyHint },
        { label: '7 dias', value: (data?.active7d ?? 0).toLocaleString() },
        { label: '15 dias', value: (data?.active15d ?? 0).toLocaleString() },
        { label: '30 dias', value: (data?.active30d ?? 0).toLocaleString() },
        { label: 'Base cadastrada', value: (metricsData?.totalUsers ?? 0).toLocaleString() },
      ]}
    />
  );
}
